import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../shared/index';

import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';
import { SettingsRouting } from './settings.routing';
import { LanguageSettingComponent } from './settings/language-setting/language-setting.component';
import { ConfigureCentralEmailComponent } from './settings/notification-settings/configure-central-email/configure-central-email.component';
import { ConfigureNotificationRecipientsComponent } from './settings/notification-settings/configure-notification-recipients/configure-notification-recipients.component';
import { NotificationSettingsDialogComponent } from './settings/notification-settings/notification-settings.component';
import { SettingComponent } from './settings/setting/setting.component';
import { SettingsComponent } from './settings/settings.component';

@NgModule({
  imports: [SharedDependenciesModule, SettingsRouting, ViDswFooterComponent],
  declarations: [
    SettingsComponent,
    LanguageSettingComponent,
    SettingComponent,
    NotificationSettingsDialogComponent,
    ConfigureCentralEmailComponent,
    ConfigureNotificationRecipientsComponent,
  ],
})
export class SettingsModule {}
